import * as ActionTypes from '../ActionTypes';

export const GetWhatsappConfigAction = (params, callback) => {
    return {
        type: ActionTypes.WHATSAPP_CONFIG_GET_REQUEST,
        params,
        callback
    };
};

export const UpsertWhatsappConfigAction = (params, callback) => {
    return {
        type: ActionTypes.WHATSAPP_CONFIG_UPSERT_REQUEST,
        params,
        callback
    };
};

export const TestWhatsappConfigAction = (params, callback) => {
    return {
        type: ActionTypes.WHATSAPP_CONFIG_TEST_REQUEST,
        params,
        callback
    };
};
